import { Vue, Component, Prop, Model, Watch, Emit } from 'vue-property-decorator'
import { VNode } from 'vue'
import { Column } from 'ant-design-vue/types/table/column'
import { ProductTypeBO } from '@/service-proxies/app-v2/product.service-proxies'

@Component
export default class FieldsTable extends Vue {
  @Prop() data: ProductTypeBO[]
  @Prop(Boolean) loading: boolean
  @Prop(Number) total: number

  @Model('changePage', { default: null }) page

  @Emit() select(val: object) {
  }

  @Watch('total')
  onChangeValue(newVal: number, oldVal: number) {
    (this.pagination as any).total = newVal
  }

  public pagination:any = {}
  public selectedRowKeys = []

  public rowSelection = {
    selectedRowKeys: this.selectedRowKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      this.selectedRowKeys = selectedRowKeys
      this.select(selectedRows)
    }
  }

  get normData() {
    this.selectedRowKeys = []
    // return this.data
    let dataLength = this.data.length;
    let copy = JSON.parse(JSON.stringify(this.data));
      let needPush = 0;
      if(dataLength < 30) {
        needPush = 30 - dataLength;
        for(var k=0; k<needPush; k++) {
          let obj = {  
            // id: 'none',
            status: 3
          }
          copy.push(obj)  
        }
      }
     return copy; 
  }

  get columns() {
    return [
      {
        title: this.$t('page_resource_pool_action'),
        width: 170,
        dataIndex: 'action',
        key: 'action',
        customRender: (_, record: ProductTypeBO) => {
          return (
            record.id &&
            <div>
              <a v-acl={'page_business_data_product_type_edit'}
                 onclick={() => this.$emit('action', {
                   type: 'auth',
                   payload: record
                 })}>{record.status === 2 ? this.$t('page_business_data_disable') : this.$t('page_business_data_enable')}</a>
              <a-divider v-acl={'page_business_data_product_type_edit'} type="vertical"/>
              <a v-acl={'page_business_data_product_type_edit'}
                 onClick={() => this.$emit('action', { type: 'edit', payload: record })}>{this.$t('edit')}</a>
              <a-divider v-acl={'page_business_data_product_type_delete'} type="vertical"/>
              <a-popconfirm
                title={this.$t('page_user_management_confirm_to_delete')}
                onConfirm={() => this.handleDel(record)}
                okText={this.$t('ok')} cancelText={this.$t('cancel')}
              >
                <a class="del-color" v-acl={'page_business_data_product_type_delete'}>{this.$t('delete')}</a>
              </a-popconfirm>
            </div>
          )
        }
      },
      {
        title: this.$t('page_docdirectory_name'),
        dataIndex: 'name',
        key: 'name',
        width: 350
      },
      {
        title: this.$t('page_business_data_description'),
        dataIndex: 'description',
        key: 'description',
        width: 180
      },
      {
        title: this.$t('page_resource_pool_status'),
        dataIndex: 'status',
        key: 'status',
        // width: 89,
        customRender: v => {
          return v === 2 ? <a-badge status="success" text={this.$t('page_business_data_enable')}/> :
            v == 3 ? '':
            <a-badge status="error" text={this.$t('page_business_data_disable')}/>
        }
      }
    ] as Column[]
  }

  handleDel(record) {
    Object.assign(this.pagination, { current: 1 })
    this.$emit('action', { type: 'delete', payload: record })
  }

  created() {
    this.pagination = {
      total: this.total,
      pageSize: this.page.pageSize,
      current: this.page.current,
      showTotal: total => (this.$t('Total…items') as string).replace('{0}', ` ${this.total} `),
      onChange: (currentPage, pageSize) => {
        const pager: any = {
          pageSize: pageSize,
          current: currentPage
        }
        Object.assign(this.pagination, pager)
        this.$emit('changePage', pager)
      },
      onShowSizeChange: (current, size) => {
        const pager: any = {
          pageSize: size,
          current: current
        }
        Object.assign(this.pagination, pager)
        this.$emit('changePage', pager)
      }
    }
  }

  handleTableChange(pagination) {
    const pager = {
      pageSize: pagination.pageSize,
      current: pagination.current
    }
    Object.assign(this.pagination, pager)
    this.$emit('changePage', pager)
  }

  onSelectChange(selectedRowKeys, selectedRows) {
    this.selectedRowKeys = selectedRowKeys
    this.select(selectedRows)
  }

  getCheckboxProps(record) {
    return ({
      style: {
        display: record.id ? 'block' : 'none'
      },
      props: {
        disabled: record.id ? false : true
      }
    })
  }

  cancelChooseArr(val) {
    this.selectedRowKeys = [];
    this.select([])
  }
  

  render(): VNode {
    return (
      <div style="height: calc(100% - 48px)">
        <div style="height:calc(100% - 60px)">
        <ml-table
          scroll={{y:(this as any).wmHeight - 240}}
          size="small"
          columns={this.columns}
          dataSource={this.normData}
          loading={this.loading}
          rowKey="id"
          // pagination={this.pagination}
          rowSelection={{ selectedRowKeys: this.selectedRowKeys, onChange: this.onSelectChange,getCheckboxProps: this.getCheckboxProps }}
          canChangeColWidth={true}
          chooseArr={this.selectedRowKeys}
          onCancelChooseArr={this.cancelChooseArr}
        ></ml-table>
        </div>
        <a-pagination
          style="float:right;margin-top:20px;margin-right:20px"
          {...{props: this.pagination}}
          onChange={this.pagination.onChange}
          onShowSizeChange={this.pagination.onShowSizeChange}
        >
        </a-pagination>
      </div>
    )
  }
}
